import 'desvg'
import templates from '@/js/templates/front'
import components from '@/js/components/_index'
import pages from '@/js/pages/_index'
import forms from '@/js/forms/_index'

window.addEventListener("DOMContentLoaded", () => {
    deSVG('img[inline]', true)
    templates()
    components()
    pages()
    forms()
})
